module.exports = __webpack_public_path__ + "static/img/preview.d3f7caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hummer-press-pass-video-campaign/preview.png
// module id = 95
// module chunks = 2